import script from "./BillingApplePriceCard16218.vue?vue&type=script&setup=true&lang=ts"
export * from "./BillingApplePriceCard16218.vue?vue&type=script&setup=true&lang=ts"

import "./BillingApplePriceCard16218.vue?vue&type=style&index=0&id=3590163d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3590163d"]])

export default __exports__